import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IoWarning } from "react-icons/io5";
import { MdBarChart, MdPlayCircle, MdOutlineTimer } from 'react-icons/md';
import TestsVector from 'assets/svg/test.svg';
import { Test } from 'global/types';
import { useAppSelector } from 'hooks/useStore';
import './index.css';

type MyTestsProps = {
    tests: Test[];
    // setTabIndex: (tabIndex: number) => void;
};

function MyTests({ tests }: MyTestsProps) {
    const navigate = useNavigate();

    const { user } = useAppSelector(state => state.user);

    return (
        <>
            <div className='myTests__plan'>
                <div className='myTests__planInfo'>
                    <h4 className='myTests__planInfoText'>
                        Current Plan: {user.bundle
                            ? <b className='myTests__planInfoPremium'>{user.bundle.name}</b>
                            : <b>Diagnostic Starter</b>
                        }
                    </h4>
                    <div className={user.bundle ? 'myTests__premium' : 'myTests__free'}>
                        <p>{user.bundle ? 'Premium' : 'Free'}</p>
                    </div>
                </div>
                
                {user.bundle
                ?   <p className='myTests__expiration'>
                        <MdOutlineTimer /> &nbsp;active until {new Date(user.bundle.expirationDate).toLocaleDateString()}
                    </p>
                :   <div className='myTests__warning'>
                        <IoWarning className='myTests__warningIcon' />
                        <p className='myTests__warningText'>
                            Please ask your tutor about if/when to upgrade your account.
                        </p>
                    </div>
                }
            </div>
            <p className='myTests__info'>When your tutor sends you an assignment, it will appear below.</p>
            {tests.find(test => !test.score && test.inProgress) && <>
                <h4 className='myTests__subHeader'>In progress</h4>
                <div className='myTests__tests'>
                    {tests.filter(test => !test.score && test.inProgress).map((test, t) => (
                        <button
                            className={test.isActive ? 'myTests__test' : 'myTests__test--disabled'}
                            onClick={() => test.isActive && 
                                ((test.type==='Digital SAT' || test.type==='Digital PSAT')
                                ? navigate(`/digital/sat/${test.testId}`)
                                : test.type==='Digital ACT'
                                ? navigate(`/digital/act/${test.testId}`)
                                : null
                            )}
                            key={test.testId}
                        >
                            <img
                                className='myTests__testVector'
                                src={TestsVector}
                            />
                            <div className='myTests__testInfo'>
                                <div className='myTests__testName'>
                                    <p className={test.type ==='Digital SAT'
                                                ? 'myTests__testTypeSAT'
                                                : test.type ==='Digital PSAT'
                                                ? 'myTests__testTypePSAT'
                                                : test.type ==='Digital ACT'
                                                ? 'myTests__testTypeACT'
                                                : 'myTests__testType'}>
                                        {test.type.replace('Digital ', '')}
                                    </p> 
                                    <h2 className='myTests__testNameContent'>Practice Test {test.testNumber}</h2>
                                </div>
                                <div className='myTests__progressBar'>
                                    <span style={{ width: 
                                        `${100*test.testSections.reduce((total, section) => (
                                            total + section.testModules.filter(module => (
                                                module.rawScore !== null
                                            )).length
                                        ), 0)/test.testSections.reduce((total, section) => (
                                            total + [...new Set(section.testModules.map(module => module.moduleNumber))].length
                                        ), 0)}%`
                                    }}></span>
                                </div>
                                <div className='myTests__progress'>
                                    <p>{100*test.testSections.reduce((total, section) => (
                                            total + section.testModules.filter(module => (
                                                module.rawScore !== null
                                            )).length
                                        ), 0)/test.testSections.reduce((total, section) => (
                                            total + [...new Set(section.testModules.map(module => module.moduleNumber))].length
                                        ), 0)}% complete
                                    </p>
                                    <p>resume {test.testSections.find(testSection => (
                                            testSection.score === null
                                        )).testModules.find(testModule => (
                                            testModule.rawScore === null
                                        )).name}
                                    </p>
                                </div>
                            </div>
                            <MdPlayCircle className='myTests__statusIcon' />
                        </button>
                    ))}
                </div>
            </>}
            {tests.find(test => !test.score && !test.inProgress) && <>
                <h4 className='myTests__subHeader'>Not started</h4>
                <div className='myTests__tests'>
                    {tests.filter(test => !test.score && !test.inProgress).map((test, t) => (
                        <button
                            className={test.isActive ? 'myTests__test' : 'myTests__test--disabled'}
                            onClick={() => test.isActive && 
                                ((test.type==='Digital SAT' || test.type==='Digital PSAT')
                                ? navigate(`/digital/sat/${test.testId}`)
                                : test.type==='Digital ACT'
                                ? navigate(`/digital/act/${test.testId}`)
                                : null
                            )}
                            key={test.testId}
                        >
                            <img
                                className='myTests__testVector'
                                src={TestsVector}
                            />
                            <div className='myTests__testInfo'>
                                <div className='myTests__testName'>
                                    <p className={test.type ==='Digital SAT'
                                                ? 'myTests__testTypeSAT'
                                                : test.type ==='Digital PSAT'
                                                ? 'myTests__testTypePSAT'
                                                : test.type ==='Digital ACT'
                                                ? 'myTests__testTypeACT'
                                                : 'myTests__testType'}>
                                        {test.type.replace('Digital ', '')}
                                    </p> 
                                    <h2 className='myTests__testNameContent'>Practice Test {test.testNumber}</h2>
                                </div>
                                <div className='myTests__progressBar'>
                                    <span style={{ width: 
                                        `${100*test.testSections.reduce((total, section) => (
                                            total + section.testModules.filter(module => (
                                                module.rawScore !== null
                                            )).length
                                        ), 0)/test.testSections.reduce((total, section) => (
                                            total + [...new Set(section.testModules.map(module => module.moduleNumber))].length
                                        ), 0)}%`
                                    }}></span>
                                </div>
                                <div className='myTests__progress'>
                                    <p>
                                        {/* {test.testSections.map((testSection, t) => (
                                            t > 0 ? ` & ${testSection.subject}` : testSection.subject
                                        ))} {test.testSections.length > 1 ? 'Sections' : 'Only'} */}
                                        {100*test.testSections.reduce((total, section) => (
                                            total + section.testModules.filter(module => (
                                                module.rawScore !== null
                                            )).length
                                        ), 0)/test.testSections.reduce((total, section) => (
                                            total + [...new Set(section.testModules.map(module => module.moduleNumber))].length
                                        ), 0)}% complete
                                    </p>
                                </div>
                            </div>
                            <MdPlayCircle className='myTests__statusIcon' />
                        </button>
                    ))}
                </div>
            </>}
            {tests.find(test => test.score) && <>
                <div className='myTests__subHeaderDiv'>
                    <h4 className='myTests__subHeader'>Completed</h4>
                    {/* <div className='myTests__subHeaderDivWrapping' onClick={() => navigate(`/tests/digital-sat/historicalReport`)}>
                        <h4 className={`myTests__subHeader myTests__button`}>View Historical Report</h4>
                        <GoArrowRight className='myTests__subHeaderIcon'/>
                    </div> */}
                </div>
                <div className='myTests__tests'>
                    {tests.filter(test => test.score).map((test, t) => (
                        <button
                            className={test.isActive ? 'myTests__test' : 'myTests__test--disabled'}
                            onClick={() => test.isActive && 
                                ((test.type==='Digital SAT' || test.type==='Digital PSAT')
                                ? navigate(`/report/digital-sat/${test.testId}`)
                                : test.type==='Digital ACT'
                                ? navigate(`/report/digital-act/${test.testId}`)
                                : null
                            )}
                            key={test.testId}
                        >
                            <img
                                className='myTests__testVector'
                                src={TestsVector}
                            />
                            <div className='myTests__testInfo'>
                                <div className='myTests__testName'>
                                    <p className={test.type ==='Digital SAT'
                                                ? 'myTests__testTypeSAT'
                                                : test.type ==='Digital PSAT'
                                                ? 'myTests__testTypePSAT'
                                                : test.type ==='Digital ACT'
                                                ? 'myTests__testTypeACT'
                                                : 'myTests__testType'}>
                                        {test.type.replace('Digital ', '')}
                                    </p> 
                                    <h2 className='myTests__testNameContent'>Practice Test {test.testNumber}</h2>
                                </div>
                                <div className='myTests__progressBar'>
                                    <span style={{ width: 
                                        `${100*test.testSections.reduce((total, section) => (
                                            total + section.testModules.filter(module => (
                                                module.rawScore !== null
                                            )).length
                                        ), 0)/test.testSections.reduce((total, section) => (
                                            total + [...new Set(section.testModules.map(module => module.moduleNumber))].length
                                        ), 0)}%`
                                    }}></span>
                                </div>
                                <div className='myTests__progress'>
                                    <p>{100*test.testSections.reduce((total, section) => (
                                            total + section.testModules.filter(module => (
                                                module.rawScore !== null
                                            )).length
                                        ), 0)/test.testSections.reduce((total, section) => (
                                            total + [...new Set(section.testModules.map(module => module.moduleNumber))].length
                                        ), 0)}% complete
                                    </p>
                                    <p>
                                        {new Date(test.testDate).toLocaleString('en-us', { year: 'numeric', month: 'numeric', day: 'numeric' })}
                                    </p>
                                </div>
                            </div>
                            <MdBarChart className='myTests__statusIcon' />
                        </button>
                    ))}
                </div>
            </>}
        </>
    );
}

export default MyTests;